import Icon from './Icon';
export { Icon };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/index.js
// module id = 971
// module chunks = 0